export const translationQueryKey = 'translation';
